// Angular
import { Injectable } from '@angular/core';

// Libraries
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root',
})
export class MissingTranslationHandlerService extends MissingTranslationHandler {
	constructor() {
		super();
	}

	handle(params: MissingTranslationHandlerParams): any {
		let newKey: string;

		if (params.key.includes('NOT') || params.key.includes('ERROR')) {
			// If error message
			// newKey = this.translateService.instant('GENERIC.ACTION_FAILED');
			newKey = 'The action failed. Please try again later, or contact the administrator';
		} else {
			// If not error message
			// newKey = this.translateService.instant('GENERIC.ACTION_SUCCEEDED');
			newKey = 'The action was successfully completed';
		}

		return newKey;
	}
}
